import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from './UserPanel/UserPanel';
import { Template } from 'devextreme-react/core/template';
import { useThemes, useBaseAppConfig } from '@core/hooks';
import { useNavigation } from '../../withNavLayout';

export default ({ menuToggleEnabled, toggleMenu }) => {
  const config = useBaseAppConfig();

  const { headerItems } = useNavigation();

  const { isDark } = useThemes();

  return (
    <header className="header-component">
      <Toolbar className="header-toolbar">
        <Item
          visible={menuToggleEnabled}
          location="before"
          widget="dxButton"
          cssClass="menu-button"
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item location="before" text={config.title || ''} />
        {headerItems.map(({ id, content }) =>
          typeof content === 'object' ? (
            <Item key={id} {...content} />
          ) : (
            content(id)
          )
        )}
        <Item
          location="after"
          locateInMenu="auto"
          menuItemTemplate="userPanelTemplate"
        >
          <Button
            className="user-button authorization"
            width={60}
            height="100%"
            stylingMode="text"
          >
            <UserPanel menuMode="context" />
          </Button>
        </Item>
        <Template name="userPanelTemplate">
          <UserPanel menuMode="list" />
        </Template>
        <Item location="after" cssClass="header-title">
          <div
            className={`header-title__img ${
              isDark ? 'header-title__img--dark' : ''
            }`}
          />
        </Item>
      </Toolbar>
    </header>
  );
};
